//@ts-check
import request from '../request';
/**
 * Get ticket info
 * @param {string} ticketId
 * @return {Promise<any>}
 */

export var getTicket = function getTicket(ticketId) {
  return request({
    url: "/backend/queuejobtickets/".concat(ticketId),
    query: {}
  });
};
export default {
  getTicket: getTicket
};